import { useState } from "react";
import { Modal } from "react-bootstrap";
import businessDocumentVM from "./businessDocumentVM";
import Index from "./index";
import selectorSection from "./selectorSection";


export const BusinessDocumentSelectorDialog = (props: {
  show: boolean;
  ok: (businessDocument: businessDocumentVM) => void;
  cancel: () => void;
  selectorSectionId: selectorSection;
}) => {
  const [selectedbusinessDocument, setSelectedbusinessDocument] =
    useState<businessDocumentVM | null>(null);

  const onClick = (businessDocument: businessDocumentVM) => {
    setSelectedbusinessDocument(businessDocument);
  };

  const onDoubleClick = (businessDocument: businessDocumentVM) => {
    setSelectedbusinessDocument(businessDocument);
    props.ok(businessDocument);
    setSelectedbusinessDocument(null); // do not preserve the selected item after closing
  };

  return (
    <div className="static-modal">
      <Modal
        animation={false}
        show={props.show}
        onHide={props.cancel}
        backdrop="static"
        keyboard={true}
        size="xl"
        fullscreen="xl-down"
      >
        <Modal.Header>
          <Modal.Title>Wybierz dokument sprzedaży</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Index
            onClick={onClick}
            onDoubleClick={onDoubleClick}
            selectorSectionId={props.selectorSectionId}
          ></Index>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            name="ok"
            className="btn btn-primary px-5 py-1"
            onClick={() => {
              props.ok(selectedbusinessDocument!);
              setSelectedbusinessDocument(null); // do not preserve the selected item after closing
            }}
            disabled={!selectedbusinessDocument}
          >
            OK
          </button>
          <button
            type="button"
            name="cancel"
            className="btn btn-secondary px-5 py-1"
            onClick={props.cancel}
          >
            Anuluj
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BusinessDocumentSelectorDialog;
